import React from 'react';
import { Phone, ShoppingCart } from 'lucide-react';
export function CartSection() {
  return <div className="flex items-center gap-3" data-id="element-414">
      <button className="p-2 text-brand-dark hover:text-brand-yellow transition-colors relative" data-id="element-415">
        <ShoppingCart className="w-6 h-6" data-id="element-416" />
        <span className="absolute -top-1 -right-1 bg-brand-yellow text-brand-dark text-xs font-bold rounded-full h-5 w-5 flex items-center justify-center" data-id="element-417">
          0
        </span>
      </button>
      <a href="tel:+18108185941" className="flex items-center justify-center rounded-md font-semibold transition-colors focus:outline-none focus:ring-2 focus:ring-offset-2 bg-brand-yellow text-brand-dark hover:bg-yellow-400 focus:ring-brand-yellow h-10 px-5 text-sm" data-id="element-418">
        <Phone className="w-4 h-4 mr-2" data-id="element-419" />
        Call Now
      </a>
    </div>;
}